const ChainLink = () => (
    <svg
        width='44'
        height='44'
        viewBox='0 0 44 44'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='22' cy='22' r='22' fill='white' />
        <path
            d='M22 6L19.037 7.7037L10.963 12.3704L8 14.0741V30.2222L10.963 31.9259L19.1111 36.5926L22.0741 38.2963L25.037 36.5926L33.037 31.9259L36 30.2222V14.0741L33.037 12.3704L24.963 7.7037L22 6ZM13.9259 26.8148V17.4815L22 12.8148L30.0741 17.4815V26.8148L22 31.4815L13.9259 26.8148Z'
            fill='#2A5ADA'
        />
    </svg>
);

export default ChainLink;
